import { resource } from '@/plugins/http'

// Api para busca das agendas
// export default resource('v1/patient/agendas')
export default resource('v1/search-engine/search')



// WEBPACK FOOTER //
// ./src/app/patient/agendas/resources/resource.js